__turbopack_context__.v({
  "content": "sheet-module-scss-module__kIYD5q__content",
  "slideIn": "sheet-module-scss-module__kIYD5q__slideIn",
  "slideOut": "sheet-module-scss-module__kIYD5q__slideOut",
});
